// extracted by mini-css-extract-plugin
export var dataCell = "_qs-2";
export var dataRow = "_qs-0";
export var headerRow = "_qs-1";